module.exports = __webpack_public_path__ + "img/checkbox.33950d05.svg";